<div class="app-shell">
  <header #masthead class="app-shell__masthead">
    <div class="app-shell__masthead-inner">
      <app-main-header></app-main-header>
      <app-main-menu></app-main-menu>
      <app-agency-header></app-agency-header>
    </div>
  </header>

  @if(authenticationService.isRefreshing){
    <div class="spinner-background">
      <div class="text-center spinner-position">
        <div class="spinner-border mb-3" style="width: 3rem; height: 3rem;" role="status"></div>
        <h5 class="text-white">Refreshing Status...</h5>
      </div>
    </div>
  }

  <main class="app-shell__main">
    <div class="application-content">
      <app-alert></app-alert>

      @if (pageLoadingService.isContentPageLoading) {
        <div class="spinner-background">
          <div class="text-center spinner-position">
            <div class="spinner-border mb-3" style="width: 3rem; height: 3rem;" role="status"></div>
            <h5 class="text-white">Loading...</h5>
          </div>
        </div>
      }

      <router-outlet></router-outlet>
    </div>
  </main>

  <footer class="app-shell__footer">
    <app-main-footer class="footer"></app-main-footer>
  </footer>
</div>
